import clsx from 'clsx'
import { useTranslation } from 'next-i18next'

const Label = ({
  text,
  optional,
  className = '',
}: {
  text: string
  optional?: boolean
  className?: string
}) => {
  const { t } = useTranslation('components')

  return (
    <p className={clsx('mb-2 text-left text-sm text-th-fgd-3', className)}>
      {text}{' '}
      {optional ? (
        <span className="ml-1 text-xs text-th-fgd-4">
          {t('forms.label.optional-marker')}
        </span>
      ) : null}
    </p>
  )
}

export default Label
